module.exports = __webpack_public_path__ + "img/grid-3x2-gap-fill.6dbde95b.svg";